import { createElementBlock as n, openBlock as o, createElementVNode as l } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(c, e) {
  return o(), n("svg", t, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12"
    }, null, -1),
    l("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M14.03 17.78a.75.75 0 0 0 0-1.06L9.31 12l4.72-4.72a.75.75 0 0 0-1.06-1.06l-5.25 5.25a.75.75 0 0 0 0 1.06l5.25 5.25a.75.75 0 0 0 1.06 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const f = { render: r };
export {
  f as default,
  r as render
};
//# sourceMappingURL=ic_chevron_left_bg-CHtXwOep.js.map
